import { render, staticRenderFns } from "./NewCollection.vue?vue&type=template&id=2f3f5452&"
import script from "./NewCollection.vue?vue&type=script&lang=js&"
export * from "./NewCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3f5452')) {
      api.createRecord('2f3f5452', component.options)
    } else {
      api.reload('2f3f5452', component.options)
    }
    module.hot.accept("./NewCollection.vue?vue&type=template&id=2f3f5452&", function () {
      api.rerender('2f3f5452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/home/NewCollection.vue"
export default component.exports